import * as React from "react";
import { IdStyles } from "../../../../less/IdStyles";
import { IdIcon } from "../../../generic/icon/IdIcon";
import { TypeNumberFormat } from "../../../generic/number-format/TypeNumberFormat";
import { BuildingUpgradeEffect } from "./BuildingUpgradeEffect";
export var BuildingUpgradeEffects = function (_a) {
    var currentStage = _a.currentStage, nextStage = _a.nextStage;
    var nextBuildingXpReward = nextStage.xp && nextStage.xp.amount ? nextStage.xp.amount : undefined;
    var nextBuildingHappinessReward = nextStage.happiness
        ? nextStage.happiness - currentStage.happiness
        : undefined;
    var nextImprovementIconReward = nextStage.improvementIcon ? nextStage.improvementIcon : "";
    var workersRequired = nextStage.workers - currentStage.workers;
    var storageCapacityChange = nextStage.storageCapacity - currentStage.storageCapacity;
    var nextStageConstructionTimeFactor = nextStage.buff && nextStage.buff.factorAddition ? nextStage.buff.factorAddition : 0;
    var currentStageConstructionTimeFactor = currentStage.buff && currentStage.buff.factorAddition
        ? currentStage.buff.factorAddition
        : 0;
    var constructionTimeChange = Math.round((nextStageConstructionTimeFactor - currentStageConstructionTimeFactor) * 100);
    return (React.createElement("div", { className: "building-upgrade__effects " + IdStyles.BuildingUpgradeEffectsWrapper },
        React.createElement(BuildingUpgradeEffect, { icon: IdIcon.XpIcn, amount: nextBuildingXpReward }),
        nextBuildingHappinessReward && nextBuildingHappinessReward !== 0 && (React.createElement(BuildingUpgradeEffect, { icon: IdIcon.HappinessPositiveIcn, amount: nextBuildingHappinessReward })),
        React.createElement(BuildingUpgradeEffect, { icon: nextImprovementIconReward }),
        workersRequired > 0 && (React.createElement(BuildingUpgradeEffect, { icon: IdIcon.WorkersIcn, amount: workersRequired, format: TypeNumberFormat.Add })),
        storageCapacityChange > 0 && (React.createElement(BuildingUpgradeEffect, { icon: IdIcon.StorageIcn, amount: storageCapacityChange, format: TypeNumberFormat.Add })),
        constructionTimeChange !== 0 && (React.createElement(BuildingUpgradeEffect, { icon: IdIcon.ConstructionTimeIcn, amount: constructionTimeChange, format: TypeNumberFormat.SignedPercent }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/upgrade/BuildingUpgradeEffects.tsx
// module id = 2861
// module chunks = 3